export const COLUMN_WIDTH_FULL = 12;
export const REGION_NAME_WITH_BOLD_FONT = ['Москва', 'Санкт-Петербург'];

export enum StatesIndex {
  'Southern' = 0,
  'Central' = 1,
  'Privolzhskiy' = 2,
  'NorthWestern' = 3,
  'Ural' = 4,
  'Siberian' = 5,
  'FarEastern' = 6,
}

export const StatesIndexArray = [
  StatesIndex.Southern,
  StatesIndex.Central,
  StatesIndex.Privolzhskiy,
  StatesIndex.NorthWestern,
  StatesIndex.Ural,
  StatesIndex.Siberian,
  StatesIndex.FarEastern,
];

export const StatesColor: Record<StatesIndex, string> = {
  [StatesIndex.Southern]: '#eac445',
  [StatesIndex.Central]: '#427fb4',
  [StatesIndex.Privolzhskiy]: '#55ab68',
  [StatesIndex.NorthWestern]: '#d65745',
  [StatesIndex.Ural]: '#d9823b',
  [StatesIndex.Siberian]: '#844ba7',
  [StatesIndex.FarEastern]: '#698392',
};

export const StateListCirclePositionIsDesktop = {
  [StatesIndex.Southern]: {
    top: {
      md: '-120px',
      lg: '-158px',
    },
  },
  [StatesIndex.Central]: {
    top: {
      md: '-208px',
      lg: '-278px',
    },
  },
  [StatesIndex.Privolzhskiy]: {
    top: {
      md: '-156px',
      lg: '-201px',
    },
  },
  [StatesIndex.NorthWestern]: {
    top: {
      md: '-265px',
      lg: '-353px',
    },
  },
  [StatesIndex.Ural]: {
    top: {
      md: '-201px',
      lg: '-262px',
    },
  },
  [StatesIndex.Siberian]: {
    top: {
      md: '-94px',
      lg: '-142px',
    },
  },
  [StatesIndex.FarEastern]: {
    top: {
      md: '-242px',
      lg: '-342px',
    },
  },
};

export const StateListCirclePositionIsMobile = {
  [StatesIndex.Southern]: {
    left: {
      xs: '6%',
    },
    top: {
      xs: '67%',
      sm: '76%',
    },
  },
  [StatesIndex.Central]: {
    left: {
      xs: '11%',
      sm: '12%',
    },
    top: {
      xs: '48%',
      sm: '55%',
    },
  },
  [StatesIndex.Privolzhskiy]: {
    left: {
      xs: '22%',
    },
    top: {
      xs: '57%',
      sm: '66%',
    },
  },
  [StatesIndex.NorthWestern]: {
    left: {
      xs: '30%',
    },
    top: {
      xs: '42%',
      sm: '47%',
    },
  },
  [StatesIndex.Ural]: {
    left: {
      xs: '43%',
    },
    top: {
      xs: '54%',
      sm: '61%',
    },
  },
  [StatesIndex.Siberian]: {
    left: {
      xs: '58%',
    },
    top: {
      xs: '67%',
      sm: '75%',
    },
  },
  [StatesIndex.FarEastern]: {
    left: {
      xs: '76%',
    },
    top: {
      xs: '43%',
    },
  },
};

export const StateListTitlePosition = {
  [StatesIndex.Southern]: {
    top: {
      md: '395px',
      lg: '560px',
    },
    left: {
      md: '5%',
      lg: '4%',
    },
  },
  [StatesIndex.Central]: {
    top: {
      md: '288px',
      lg: '399px',
    },
    left: {
      md: '11%',
      lg: '12%',
    },
  },
  [StatesIndex.Privolzhskiy]: {
    top: {
      md: '339px',
      lg: '468px',
    },
    left: {
      md: '18%',
      lg: '19%',
    },
  },
  [StatesIndex.NorthWestern]: {
    top: {
      md: '250px',
      lg: '350px',
    },
    left: {
      md: '24%',
      lg: '27%',
    },
  },
  [StatesIndex.Ural]: {
    top: {
      md: '315px',
      lg: '440px',
    },
    left: {
      md: '45%',
      lg: '47%',
    },
  },
  [StatesIndex.Siberian]: {
    top: {
      md: '400px',
      lg: '560px',
    },
    left: {
      md: '61%',
      lg: '60%',
    },
  },
  [StatesIndex.FarEastern]: {
    top: {
      md: '252px',
      lg: '360px',
    },
    left: {
      md: '67%',
      lg: '68%',
    },
  },
};
